import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AboutUs from './aboutUs';
import ServicesAndFeatures from './services';
// import BlogPosts from './blogPosts';
import SkewPatternImg from '../i/skew-pattern.png';

const styles = {
  landingContent: {
    position: 'relative',
  },
  skew: {
    position: 'absolute',
    width: '100%',
    top: '-374px',
    height: '100%',
    // clipPath: 'polygon(100% 0%, 100% 69%, 64% 100%, 0 100%, 0 46%, 47% 24%)',
    // background: 'linear-gradient(160deg, #334956, #2D404C)',
    zIndex: '-1',
    background: '#334956',
  },
};

const LandingContentContainer = ({ classes }) => (
  <div className={classes.landingContent}>
    <span className={classes.skew} />
    <ServicesAndFeatures />
    {/* <BlogPosts /> */}
    <AboutUs />
  </div>
);

export default withStyles(styles)(LandingContentContainer);

LandingContentContainer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

LandingContentContainer.defaultProps = {
  classes: {},
};
